<template>
  <v-dialog v-model="dialog" fullscreen hide-overlay scrollable transition="dialog-bottom-transition">
    <v-card class="d-flex flex-column" style="height: 100vh">
      <v-toolbar color="primary" dense class="elevation-0 flex-grow-0" dark>
        <v-btn icon dark @click="cancel" class="mr-2">
          <v-icon>mdi-close</v-icon>
        </v-btn>
        <v-toolbar-title>Tạo Đợt Kiểm Kê Tài Sản</v-toolbar-title>
        <v-spacer />
      </v-toolbar>
      <v-card-text class="pa-6 flex-grow-1" style="overflow-y: auto">
        <div class="mx-auto" style="max-width: 1600px">
          <AuditForm ref="auditForm" />
        </div>
      </v-card-text>
      <v-divider />
      <v-card-actions class="pa-4 white elevation-2 flex-grow-0">
        <v-btn outlined @click="cancel">HUỶ</v-btn>
        <v-spacer />
        <v-btn color="primary" depressed @click="save"> <v-icon left small>mdi-check</v-icon> Lưu</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import AuditForm from '@/modules/facility/audit/AuditForm.vue'
import { mapActions } from 'vuex'

export default {
  name: 'AuditNewDialog',
  components: { AuditForm },
  props: {
    state: Boolean
  },
  data() {
    return {
      dialog: false
    }
  },
  watch: {
    state(val) {
      if (val) {
        this.dialog = true
        this.$nextTick(() => {
          if (this.$refs.auditForm && typeof this.$refs.auditForm.initForm === 'function') {
            this.$refs.auditForm.initForm()
          }
        })
      }
    }
  },
  methods: {
    ...mapActions('FacilityAudits', ['createAudit']),
    cancel() {
      this.dialog = false
      if (this.$refs.auditForm) {
        this.$refs.auditForm.resetValidation()
      }
    },
    async save() {
      if (!this.$refs.auditForm.validate()) return

      this.$loading.active = true
      try {
        const payload = this.$refs.auditForm.getData()
        await this.createAudit(payload)
        this.dialog = false
        this.$emit('updated')
      } catch (error) {
        this.$alert.error(error)
      } finally {
        this.$loading.active = false
      }
    }
  }
}
</script>
